import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link as RouterLink } from "react-router-dom";
import { makeStyles, withStyles} from '@material-ui/styles';

import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button
} from '@material-ui/core';

import firebase from '../../Firebase';
import 'firebase/database';
import { SIREN_CONFIG, SIREN_COLOR, CONFIG_SETTINGS } from 'config.js';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";



const COLUMN_WIDTH = {
  NO : '3%',
  ROOM : '27%',
  STATUS: '10%', //40
  TIME: '14%', //54
  OCCURFROM: '10%', //64
  ACTOR: '16%', //80
  ACTION: '20%'
}



const EmergencyTextTypography = withStyles({
  root: {
    backgroundColor: SIREN_COLOR.EMERGENCY_BG2_COLOR,
  }
})(Typography);

const CautionTextTypography = withStyles({
  root: {
    backgroundColor: SIREN_COLOR.CAUTION_BG2_COLOR,
  }
})(Typography);


/**
 * 긴급 상태 센서 테이블
 */
const EmergencyTable = props => {
  const { className, users, emergencyRowPerPage, ...rest } = props;

  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [rowsPerPage, setRowsPerPage] = useState(emergencyRowPerPage);
  const [page, setPage] = useState(0);

  const [listData, setListData] = useState([]);
  const firebaseRootRef = useSelector((store) => store.envSettings.firebaseRootRef)
  const facility_id = useSelector((store) => store.user.facility_id);


  const searchData = () => {

    fetch(`${SIREN_CONFIG.HOSTNAME}/emergency/lastEmergencyList?facility_id=${facility_id}&status=EMERGENCY`)
    .then(res => res.json())
    .then(snapshot => {
      var list  = [];
      if( snapshot != null){
        var no = 1;

        if (snapshot.resultData != null) {
          snapshot.resultData.forEach( doc => {
            doc.no = no++;
            list.push(doc);
          });
        }
      }
      setListData( list );
    }
    );
  }


  useEffect( () => {

    if (firebaseRootRef == null || firebaseRootRef.length == 0) return;

    firebase.database().ref('/dashboard/'+ firebaseRootRef ).child("dashboard").child('emergency').on('value', (snapshot) => {
      //realtime DB값이 변경되면, 긴급 상태 목록을 갱신한다.
      searchData();
    });


    return () => {};
  }, []);


  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
    localStorage.setItem(CONFIG_SETTINGS.EmergencyRowsPerPage, event.target.value);
  };



  const startRow = (page*rowsPerPage);


  return (

    <Card className={clsx(classes.root, className)} {...rest} >

      <CardHeader
        title={formatMessage({id:'emergency_table_title'})}
        titleTypographyProps={{ align: "center", variant:'h4' }}
        subheader={formatMessage({id:'emergency_table_subheader'})}
        subheaderTypographyProps={{align: "right", variant: "caption"}}
      />

      <Divider />

      <CardContent className={classes.content}>
        <PerfectScrollbar style={{ height: CONFIG_SETTINGS.TABLE_HEIGHT }}>
          <div className={classes.inner}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell width={COLUMN_WIDTH.NO} align="center" className={classes.nameContainer}>No</TableCell>
                  <TableCell width={COLUMN_WIDTH.ROOM} align="center">{<FormattedMessage id="emergency_table_room" />}</TableCell>
                  <TableCell width={COLUMN_WIDTH.STATUS} align="center">{<FormattedMessage id="emergency_table_status" />}</TableCell>
                  <TableCell width={COLUMN_WIDTH.TIME} align="center">{<FormattedMessage id="emergency_table_occurTime" />}</TableCell>
                  <TableCell width={COLUMN_WIDTH.OCCURFROM} align="center">{<FormattedMessage id="emergency_table_occurFrom" />}</TableCell>
                  <TableCell width={COLUMN_WIDTH.ACTOR} align="center">{<FormattedMessage id="emergency_table_actor" />}</TableCell>
                  <TableCell width={COLUMN_WIDTH.ACTION} align="center">{<FormattedMessage id="emergency_table_action" />}</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {listData.slice(0+startRow, rowsPerPage+(page*rowsPerPage)).map(module => (

                 <TableRow
                    key={module.eventId}
                    component={RouterLink} to={`/firstaid/update/${module.eventId}`}
                    >

                    <TableCell width={COLUMN_WIDTH.NO} align="center">
                      <div className={classes.nameContainer}>
                        <Typography variant="body2">{module.no}</Typography>
                      </div>
                    </TableCell>

                    <TableCell width={COLUMN_WIDTH.ROOM} align="left">
                      <Typography variant="body1">{module.roomName}&nbsp;<Typography variant="caption">{module.installed_pos_detail}</Typography></Typography>
                    </TableCell>

                    <TableCell width={COLUMN_WIDTH.STATUS} align="center">
                      <EmergencyTextTypography>{formatMessage({id:module.status})}</EmergencyTextTypography>
                    </TableCell>

                    <TableCell width={COLUMN_WIDTH.TIME} align="center">
                      <Typography variant="caption">
                       {moment(module.firstEventTime).format('MM.DD HH:mm')}
                       </Typography>
                    </TableCell>

                    <TableCell width={COLUMN_WIDTH.OCCURFROM} align="center">
                      <Typography variant="caption">
                      {module.occurFrom == '0' ? formatMessage({id:'emergency_table_occurFrom_sensor'}) : formatMessage({id:'emergency_table_occurFrom_backend'}) }
                      </Typography>
                    </TableCell>

                    <TableCell width={COLUMN_WIDTH.ACTOR} align="center"><Typography variant="caption">{module.actionUser}</Typography></TableCell>
                    <TableCell width={COLUMN_WIDTH.ACTION} align="center">
                      {
                        module.action ?
                        <Typography variant="caption">{module.action}</Typography>
                        : (
                          <Button
                          color="primary"
                          variant="contained"
                          size="small"
                        >
                          <FormattedMessage id="emergency_table_act" />
                        </Button>
                        )
                      }
                    </TableCell>
                  </TableRow>

                ))}

              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>

      <Divider />

      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={listData.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10]}
        />
      </CardActions>
    </Card>
  );
};

EmergencyTable.propTypes = {
  className: PropTypes.string,
};


export default EmergencyTable;


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    // minWidth: 1050
  },
  nameContainer: {
    // display: 'flex',
    // alignItems: 'center',
    // marginLeft: theme.spacing(1)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },
}));